import store from './store/store';
import moment from 'moment';
import uuidv4 from "uuid/v4";
import BlumarConfig from './blumar-config';

export function handleInvalidation(event, action) {
  if (store.state.invalidInput === undefined) {
    store.dispatch('invalidInput', event.target);
    action();
    setTimeout(() => {
      store.state.invalidInput.reportValidity();
      store.dispatch('invalidInput', undefined);
    }, 100);
  }
}

export class DateRange {
	static * iterate(startDate, endDate, format) {
		let offset = endDate.diff(startDate, 'days');
		let current = moment(startDate);
		while (offset >= 0) {
			yield current.format(format);
			offset--;
			current.add(1, 'days');
		}
	}
}

export function patch(target, source) {
	let targetKeys = Object.keys(target);
	let sourceKeys = Object.keys(source);
	let fieldsToPatch = sourceKeys.filter(key => targetKeys.includes(key));
	fieldsToPatch.forEach(key => target[key] = source[key] !== undefined ? source[key] : target[key]);
}

export async function fetchModel(name, fetch, defaultValue) {
	try {
		var { data } = await fetch();
		return data;
	} catch(error) {
		console.error(error);
		store.dispatch("showAlert", { message: `Erro ao buscar ${name}!`, code: 0, style: "danger" });
		return defaultValue || [];
	}
}

export async function requestAction(successMsg, failureMsg, action) {

	try {
		let ret = action instanceof Promise ? action : action();
		let res = ret instanceof Promise ? await ret : ret;
		store.dispatch("showAlert", { message: successMsg, code: 0, style: "success" });
		if (res && res.data) return res.data;
		return res;
	} catch (error) {
		store.dispatch("showAlert", { message: failureMsg, code: 0, style: "danger" });
		throw error;
	}

}

export function fieldValues(object) {
	return Object.keys(object).map(key => object[key]);
}

export function readInputFile(file, callback) {
	let fileNameSplit = file.name.split(".");
	let fileExtension = fileNameSplit[fileNameSplit.length - 1];
	let fileName = `${uuidv4()}.${fileExtension}`;

	const reader = new FileReader();
	reader.readAsDataURL(file);
	reader.onload = function() {
		let imageAsEncoded64 = reader.result.split(",")[1];
		callback({ name: fileName, content: imageAsEncoded64 });
	};
}

export function range(size, start) {
	let result = [...Array(size).keys()];
	if (start) return result.map(i => i + start);
	return result;
}

export async function viaCep(cep) {
	let res = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
	return await res.json();
}

export function formatNumber(number, fractions) {
	return new Intl.NumberFormat('pt-br', {
		useGrouping: false,
		minimumFractionDigits: fractions,
		maximumFractionDigits: fractions
	}).format(number);
}

export function getNumber(blumarNumber) {
	return blumarNumber ? Number(blumarNumber.replace(',', '.')) : blumarNumber;
}

export function getDate(blumarDate) {
	return moment(blumarDate, "DD/MM/YYYY");
}

export function checkDateString(dateString) {
	return dateString ? dateString.match("[1-9][0-9]\/[0-9]{2}\/[0-9]{4}") : false;
}

export const alerter = {
	warn(message, code = 0) {
		store.dispatch("showAlert", {message, code, style: 'warning'});
		return false;
	},
	danger(message, code = 0) {
		store.dispatch("showAlert", {message, code, style: 'danger'});
		return false;
	},
	success(message, code = 0) {
		store.dispatch("showAlert", {message, code, style: 'success'});
	}
};

export function deepCopy(source) {
	let result = JSON.parse(JSON.stringify(source));
	Object.setPrototypeOf(result, Object.getPrototypeOf(source));
	return result;
}

export function getStorageUrl(path) {
	return `https://${BlumarConfig.blumarCdn}.blumar.com.br/${path}`
}

export function baseFileName(filename) {
	return filename.split('\\').pop().split('/').pop();
}

export function downloadFile(filePath, fetchFile) {
	return fetchFile(filePath)
		.then(({ data }) => {
			const url = URL.createObjectURL(data);
			const a = document.createElement('a');
			a.href = url;
			a.download = filePath.split('/').pop();
			a.click();
			URL.revokeObjectURL(url);
		})
		.catch((error) => {
			alerter.danger(`Erro ao baixar arquivo!`);
		});
}

export function idGenerator(from = 1) {
	let key = Math.random().toString(36).substring(7);
	return () => key + from++;
}

export function formatLocalDateTime(strLocalDateTime, strFormat="DD/MM/YYYY HH:mm:ss") {
	let currentDate = new Date(strLocalDateTime);
	return moment(currentDate).format(strFormat);
}



// WEBPACK FOOTER //
// ./src/utils.js